export const getAddressComponents = components => {
  const getComponent = type =>
    components.filter(component => component.types.includes(type))[0] || {}

  const streetNo = getComponent('street_number').long_name
  const streetName = getComponent('route').long_name
  const locality = getComponent('locality').long_name
  const region = getComponent('administrative_area_level_1').short_name
  const postalCode = getComponent('postal_code').short_name
  const country = getComponent('country').long_name

  return {
    streetNo,
    streetName,
    postalCode,
    locality,
    region,
    country,
  }
}

export const getAddressText = address => {
  if (!address) {
    return ''
  }

  return (
    [address.streetNo, address.streetName, address.locality, address.region, address.country]
      .filter(c => c)
      .join(', ') || ''
  )
}
